import React from 'react';
import Modal from '../Modal';

import { ReactComponent as CloseIcon } from '../images/x.svg';
import { ReactComponent as Spinner } from '../images/spinner.svg';

const ChargeModal = ({ setVisible, userId }) => {
  const [amount, setAmount] = React.useState('');
  const [status, setStatus] = React.useState('idle');

  async function chargeUser() {
    if (amount === '') return;

    setStatus('loading');

    try {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/charge-user', {
        method: 'POST',
        headers: {
          'Authorization': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId,
          amount,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setStatus('success');
      } else {
        setStatus('failed');
      }
    } catch (error) {
      console.log(error);
      setStatus('failed');
    }
  }

  return (
    <Modal isOpen={true} zIndex={200}>
      <div style={{
             background: 'linear-gradient(gray, transparent)',
             zIndex: '101',
             position: 'absolute',
             transform: 'translate(-50%, -50%)',
             top: '50%',
             left: '50%',
             width: '500px',
             borderRadius: '10px',
           }}>
        <div style={{
               margin: '1px',
               borderRadius: '10px',
               zIndex: '1002',
               display: 'flex',
               flexDirection: 'column',
               padding: '20px',
               backgroundColor: 'black',
               gap: '20px',
             }}>
          <div style={{
                 display: 'flex',
                 flexDirection: 'row',
                 alignItems: 'center',
                 justifyContent: 'space-between',
                 width: '100%',
               }}>
            <span style={{
                    fontSize: '22px',
                    fontWeight: 'bold',
                  }}>
              Charge user
            </span>

            <CloseIcon
              className="image"
              style={{
                width: '15px',
                height: '15px',
                fill: 'white',
              }}
              onClick={() => setVisible(false)}
            />
          </div>

          {status === 'idle' && (
            <>
              <input
                type="number"
                placeholder="Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                min={0}
                style={{
                  width: '100%',
                  boxSizing: 'border-box',
                  padding: '12px',
                  borderRadius: '6px',
                  border: '1px solid gray',
                  backgroundColor: '#111',
                  color: 'white',
                  fontSize: '16px',
                  outline: 'none',
                }}
              />

              <button
                onClick={chargeUser}
                style={{
                  padding: '12px',
                  borderRadius: '6px',
                  border: 'none',
                  backgroundColor: '#009de6',
                  color: 'white',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}>
                Charge
              </button>
            </>
          )}

          {status === 'loading' && (
            <div style={{
                   height: '150px',
                   display: 'flex',
                   flexDirection: 'column',
                   alignItems: 'center',
                   justifyContent: 'center',
                   gap: '15px',
                 }}>
              <Spinner style={{
                         width: '70px',
                         height: '70px',
                         animation: 'spin 1s linear infinite',
                       }} />
              <span>Charging user...</span>
            </div>
          )}

          {status === 'success' && (
            <div style={{
                   height: '100%',
                   display: 'flex',
                   flexDirection: 'column',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   paddingTop: '0px',
                   paddingBottom: '0px',
                   gap: '50px',
                 }}>
              <div style={{
                     flex: 1,
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     fontSize: '20px',
                     fontWeight: 'bold',
                   }}>
                Successfully charged!
              </div>

              <div
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#009de6',
                  color: 'white',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '20px',
                }}
                onClick={() => setVisible(false)}>
                OK
              </div>
            </div>
          )}

          {status === 'failed' && (
            <div style={{
                   height: '100%',
                   display: 'flex',
                   flexDirection: 'column',
                   justifyContent: 'space-between',
                   alignItems: 'center',
                   paddingTop: '0px',
                   paddingBottom: '0px',
                   gap: '50px',
                 }}>
              <div style={{
                     flex: 1,
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     fontSize: '20px',
                     fontWeight: 'bold',
                     color: 'red',
                   }}>
                Charge failed!
              </div>

              <div
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#009de6',
                  color: 'white',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '20px',
                }}
                onClick={() => setVisible(false)}>
                OK
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ChargeModal;
